export default __webpack_public_path__ + "static/energy-boiler-cover-reward-terms-2d6254976b1e5ebef9847ae9b079a931.pdf";